import { useLayoutEffect, useState } from "react";
import Header from "../../../components/Header";
import backglow from "../../../assets/backglow.svg";
import Footer from "../../../components/Footer";
import { usecases } from "../../../data";
import { useParams } from "react-router-dom";
import wave2 from "../../../assets/wave2.png";
import back from "../../../assets/back.png";
import { useHistory } from "react-router-dom";
import ReactPlayer from "react-player";
import Bottom from "../../../components/Bottom";
import { TitleComponent } from "../../../TitleComponent";

const UsecaseId = () => {
  const { tag } = useParams();
  const history = useHistory();
  const [data, setData] = useState(usecases.filter((item) => item.tag === tag));
  const [heading, setHeading] = useState(data[0].heading);
  const [videoLink, setVideoLink] = useState(data[0].videoLink);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <TitleComponent
        title={data[0].title}
        description={data[0].description || "Create royalty-free, background music with the power of AI. Recommended for videos, podcasts & games. Try now!"}
      />
      {/* header*/}
      <Header />
      {/* hero */}
      <section className="w-full">
        <div className="relative w-full">
          <img
            src={wave2}
            alt="Bg-Wave"
            className="absolute -z-10 -top-20 w-full object-cover mobile:h-screen sm:h-screen md:h-screen"
          />
          <div className="flex items-center justify-center mobile:flex-col ">
            <div className="absolute z-50 left-24 mobile:top-20 mobile:left-16 sm:left-16 sm:top-20 md:left-16 md:top-20">
              <div className="flex gap-2 items-center cursor-pointer" onClick={history.goBack}>
                <img src={back} alt="Bg-wave" />
                <p className="font-poppins font-normal text-lg leading-7 text-green">
                  All Use Cases
                </p>
              </div>
            </div>
            <div className="flex flex-col justify-center items-center py-28 z-20">
              <h1 className="font-bold text-5xl text-center my-7 mx-0 text-white max-w-4xl leading-relaxed font-poppins mobile:text-2xl sm:text-3xl md:text-4xl">
                {heading}
              </h1>
            </div>
          </div>
        </div>
      </section>
      {/* video */}
      {videoLink && (
        <section className="max-w-6xl mx-auto">
          <div className="relative px-5">
            <img
              src={backglow}
              alt="Glow"
              loading="lazy" 
              className="absolute -z-10 w-full left-10 top-0 sm:max-w-md mobile:max-w-xs mobile:left-0 mobile:top-0 md:max-w-sm md:mb-80"
              width="100%"
              height="auto"
            />
            <ReactPlayer
              className="w-full relative aspect-w-16 aspect-h-9"
              url={videoLink}
              width="100%"
              controls={true}
              config={{
                youtube: {
                  playerVars: { showinfo: 1 },
                },
              }}
            />
          </div>
        </section>
      )}

      {/*about */}
      <section className="max-w-7xl mx-auto py-20">
        {data.map((item, key) => (
          <div className="grid grid-cols-3 gap-10 sm:grid-cols-2 mobile:grid-cols-1 px-10">
            {item.desc.map((item, key) => (
              <div
                className="max-w-md h-auto border-0 rounded-xl backdrop-blur-3xl bg-black-nblack backdrop-filter py-10 px-5 "
                key={key}
              >
                <h3
                  className="font-bold bg-clip-text	text-1xl leading-9 font-poppins mb-5"
                  style={{
                    "backgroundImage": "linear-gradient(89.35deg, rgb(255, 90, 250) 12.26%, rgb(0, 240, 255) 99.17%)",
                    "backgroundClip": "text",
                    WebkitTextFillColor: "transparent",
                    WebkitBackgroundClip: "text",
                  }}
                >
                  {key + 1}. {item.link}
                </h3>
                <p className="font-mulish font-normal text-base text-white opacity-80 leading-6">
                  {item.text}
                </p>
              </div>
            ))}
          </div>
        ))}
      </section>
      {/* cta */}
      <section className="max-w-5xl mx-auto py-20 mobile:px-8 sm:px-5 md:px-5">
        <Bottom
          heading={"Find the tune that carries your story"}
          paragraph={
            "Create unique royalty-free music that matches the various moods of your content."
          }
          ctaButton={"Get Started"}
        />
      </section>
      {/* footer */}
      <section className="max-w-7xl mx-auto">
        <Footer />
      </section>
    </>
  );
};

export default UsecaseId;
